export const strings = {
  filters: 'Filtreler',
  verify_user: 'Lisansı Doğrula',
  all_microsite: 'Tüm Mikrosite',
  license: 'Lisans',
  prev: 'Önceki',
  hide: 'Saklamak',
  advance_search: 'Gelişmiş Arama',
  next: 'Sonraki',
  license_no: 'Sayı',
  verify: 'Doğrulamak',
  unverify: 'Doğrulamayı iptal et',
  name: 'İsim',
  email: 'E-posta',
  joining_date: 'Kayıt Ol',
  email_activated: 'E-posta Etkinleştirildi',
  license_verified: 'Lisans Doğrulandı',
  start_date: 'Başlangıç Tarihi',
  end_date: 'Bitiş Tarihi',
  name_email: 'İsim veya E-posta',
  user_verified: 'Kullanıcı Doğrulandı',
  reset_password: 'Şifreyi Sıfırla',
  license_name: 'İsim',
  user_details: 'Kullanıcı Detayları',
  license_issue_org: 'Sorun Organizasyonu',
  license_issue_date: 'Düzenleme tarihi',
  license_end_date: 'Son kullanma tarihi',
  license_id: 'Lisans Kimliği',
  files: 'Lisans Dosyaları',
  no_files: 'Lisans Dosyası Yok',
  home: 'Ev',
  users: 'Kullanıcılar',
  search: 'Aramak',
  download: 'İndirmek',
  send_report: 'Rapor Gönder',
  overview: 'Genel bakış',
  admin_dashboard: 'Yönetici Panosu',
  send_email_reminders: 'E-posta Hatırlatıcıları Gönder',
  thirty_days: 'Son 30 gün',
  sixty_days: 'Son 60 gün',
  ninety_days: 'Son 90 gün',
  user_onboarding: "Kullanıcı Onboarding'i",
  reports: 'Raporlar',
  eConsultation: 'eDanışmanlık',
  all_users: 'Tüm Kullanıcılar',
  active_users: 'Aktif Kullanıcılar',
  inactive_users: 'Etkin Olmayan Kullanıcılar',
  country_placeholder: 'Tüm Ülkeler',
  speciality_placeholder: 'Tüm Uzmanlıklar',
  eq_placeholder: 'En yüksek EQ',
  all_activities: 'Tüm Etkinlikler',
  feeds: 'Beslemeler',
  articles: 'Makaleler',
  cases: 'Davalar',
  registered_users: 'Kayıtlı Kullanıcılar',
  custom: 'Gelenek',
  from: 'İtibaren',
  to: 'İle',
  submit: 'Göndermek',
  cancel: 'İptal etmek',
  email_analytics: 'E-posta Analitiği',
  onboarding_analytics: 'Onboarding Analitiği',
  engagement_analytics: 'Katılım Analitiği',
  email_reminder: 'E-posta Hatırlatıcısı Gönderiliyor...',
  email_reminder_desc:
    'Seçilen aktivite türü için bir hatırlatma e-postası aşağıdaki SMM kullanıcılarına gönderilecektir',
  activity_type: 'E-posta Etkinlik Türü',
  onboarding: 'Gemiye binme',
  engagement: 'Nişanlanmak',
  select_template: 'Şablon Seçin',
  select_date: 'Tarih Seçin',
  select: 'Seçme',
  write_here: 'Buraya yaz',
  comments: 'Yorumlar (İsteğe bağlı)',
  search_users: 'SMM Kullanıcılarını Ara',
  show_all_users: 'Tüm Yeni Kullanıcıları Göster',
  email_not_verified: 'E-posta Doğrulanmadı Yalnızca',
  license_not_verified: 'Lisans Doğrulanmadı Sadece',
  active_email: 'E-posta Etkinleştirildi',
  name_or_email: 'İsim veya E-posta',
  date_placeholder: 'Tarih girin',
  load_more: 'Daha Fazlasını Yükle',
  view_user: 'Kullanıcı Profilini Görüntüle',
  engagement_mail: 'Nişan E-postası Gönder',
  manage_settings: 'Ayarları Yönet',
  deactivate_account: 'Hesabı Devre Dışı Bırak',
  account_delete_confirmation:
    'Bu hesabı devre dışı bırakmak istediğinizden emin misiniz?',
  delete_suggestion:
    'Bu profili devre dışı bırakmak hesabı devre dışı bırakacak ve kullanıcı tekrar oturum açtığında yeniden etkinleştirilecektir',
  make_email_verified: 'E-postayı Doğrulanmış Olarak Yap',
  email_verified_badge: 'E-posta Doğrulanmadı',
  licence_verified_badge: 'Lisans Doğrulanmadı',
  activate_account: 'Hesabı Etkinleştir',
  edit_profile: 'Profili Düzenle',
  view_profile: 'Kullanıcı Profilini Görüntüle',
  content_engagements: 'İçerik Etkileşimleri',
  engagement_summary: 'Kullanıcı Katılım Özeti',
  post_engagement_overview: 'Gönderiler Etkileşim Genel Bakışı',
  likes: 'Beğeniler',
  shares: 'Paylaşımlar',
  connections: 'Bağlantılar',
  groups: 'Gruplar',
  microsites: 'Mikrositeler',
  profile_completion: 'Profil Tamamlama',
  top_five_users: 'En Aktif 5 Kullanıcı',
  engagement_eq: 'Katılım Katsayısı (EQ)',
  no_profile_views: 'Profil Görüntüleme Sayısı',
  no_times_login: 'Giriş Sayısı',
  avg_time_spent: 'Ort. Harcanan Zaman',
  no_feed_post: 'Yayınlanan Besleme Sayısı',
  no_survey_participated: 'Katılan Anket Sayısı',
  no_webinar_attended: 'Katılan Web Seminerlerinin Sayısı',
  feeds_engagement: 'Besleme Katılımı',
  average_daily_active_users: 'Ort. Günlük aktif kullanıcı sayısı',
  total_active_users_daily: 'Günlük Aktif Kullanıcıların Toplam Sayısı',
  search_name_or_email: 'E-posta veya isme göre arama yapın',
  email_batches: 'E-posta Grupları',
  email_batch_status: 'E-posta Toplu Durumu',
  all: 'Tüm',
  posted: 'Yayımlandı',
  liked: 'Beğenildi',
  commented: 'Yorumlandı',
  shared: 'Paylaşılan',
  expert_panel: 'Uzmanlar Paneli',
  last_login: 'Son Giriş',
  export_case: 'Vaka Analitiğini İndir',
  export_expert: 'Panel Analitiğini İndir',
  license_status: 'Lisans Durumu',
  unverified_status:
    'Hesabınız doğrulanıyor, kısa süre içinde yeni vakalar ekleyebileceksiniz',
};
